import React, { useState, useEffect } from 'react';
import { X, ChevronDown } from 'lucide-react';

const INTERVIEWERS = [
  { name: 'John Doe (Recruiter)', color: '#FFB4B4' },
  { name: 'Jane Smith (Recruiter)', color: '#B4FFB4' },
  { name: 'Mike Johnson (Recruiter)', color: '#B4B4FF' },
  { name: 'Sarah Williams (Recruiter)', color: '#FFE4B4' },
];

function InterviewerModal({ isOpen, onClose, onSave, candidate, recruiters, assignEvent, event }) {
  const [selectedInterviewer, setSelectedInterviewer] = useState(event?.recruiter);

  // console.log("event", event);

  if (!isOpen) return null;

  // Format event details
  const formatDateTime = (isoString) => {
    if (!isoString) return 'Not Available';
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  const handleClose = () => {
    onClose();
    setSelectedInterviewer(null);
  };

  const eventDetails = {
    id: event?.id || 'Not Available',
    startTime: formatDateTime(event?.scheduled_start_time),
    endTime: formatDateTime(event?.scheduled_end_time),
    candidateName: event?.user?.name || event?.payload?.emails || 'Not Available',
  };

  // useEffect(() => {
  //   if(event?.recruiter){
  //     setSelectedInterviewer(event?.recruiter);
  //   }
  // }, [event?.recruiter]); // Add event?.recruiter as dependency to prevent hooks mismatch

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-card rounded-lg p-6 w-[90%] max-w-[384px] relative m-4">
        <button
          onClick={handleClose}
          className="absolute right-4 top-4 text-muted-foreground hover:text-foreground"
        >
          <X className="w-5 h-5" />
        </button>
        <h2 className="text-xl font-semibold mb-4">Select Recruiter</h2>
        <div className=" border border-border rounded-lg p-4 mb-4">
          <ul className="text-muted-foreground text-sm space-y-1">
            {/* <li><span className="font-medium">Event ID:</span> {eventDetails.id}</li> */}
            <li><span className="font-medium">Start Time:</span> {eventDetails.startTime}</li>
            <li><span className="font-medium">End Time:</span> {eventDetails.endTime}</li>
            <li><span className="font-medium">Candidate:</span> {eventDetails.candidateName}</li>
          </ul>
        </div>
        {candidate && (
          <p className="text-muted-foreground mb-4">
            Assign a recruiter for {candidate}'s interview
          </p>
        )}
        
        <div className="relative">
          <select
            value={selectedInterviewer?.name || event?.recruiter?.name || ''}
            onChange={(e) => {
              const interviewer = recruiters.find(i => i.name === e.target.value);
              setSelectedInterviewer(interviewer || null);
            }}
            className="w-full p-3 pr-10 rounded-lg bg-card border border-input text-foreground appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select a recruiter...</option>
            {recruiters.map((interviewer) => (
              <option key={interviewer.id} value={interviewer.name}>
                {interviewer.name}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none w-5 h-5" />
        </div>

        <div className="mt-6 flex justify-between space-x-3">
          <div className='flex gap-2 justify-start'>
          <button
              onClick={() => window.open(event?.payload?.scheduled_event?.location?.join_url, '_blank')}
              className="px-4 py-2 text-sm bg-primary hover:bg-primary/80 text-white rounded-lg"
            >
              Join
            </button>
          </div>
          <div className='flex gap-2 justify-end'>
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm text-muted-foreground hover:text-foreground"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                if (selectedInterviewer) {
                  onSave(selectedInterviewer.id, event.id);
                  onClose();
                }
              }}
              disabled={!selectedInterviewer}
              className="px-4 py-2 text-sm bg-primary text-white rounded-lg hover:bg-primary/80 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Assign
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InterviewerModal;